import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const BALANCE_MENU: PermissionTableRowType = {
  name: '정산',
  key: 'BALANCE_MANAGE',
  subRows: [
    {
      name: '정산 관리',
      key: PERMISSION_SUBJECTS.BALANCE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.BALANCE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '정산 상세 조회',
          key: PERMISSION_SUBJECTS.BALANCE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '정산 처리',
          key: PERMISSION_SUBJECTS.BALANCE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '정산 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.BALANCE,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '브랜드별 정산 타입 목록',
      key: PERMISSION_SUBJECTS.STORE_BALANCE,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.STORE_BALANCE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '엑셀 다운로드',
          key: PERMISSION_SUBJECTS.STORE_BALANCE,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '정산 기준일 변경',
      key: PERMISSION_SUBJECTS.SETTLEMENT_DATE_ADJUSTMENT,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '변경 이력/배치 목록 조회',
          key: PERMISSION_SUBJECTS.SETTLEMENT_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '대기 정산건/배치 상세/Preview/검증 조회',
          key: PERMISSION_SUBJECTS.SETTLEMENT_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '기준일 변경 실행',
          key: PERMISSION_SUBJECTS.SETTLEMENT_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '롤백',
          key: PERMISSION_SUBJECTS.SETTLEMENT_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      name: '정산 완료일 변경',
      key: PERMISSION_SUBJECTS.SETTLEMENT_COMPLETE_DATE_ADJUSTMENT,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '변경 이력/배치 목록 조회',
          key: PERMISSION_SUBJECTS.SETTLEMENT_COMPLETE_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '완료 정산건/배치 상세/Preview/검증 조회',
          key: PERMISSION_SUBJECTS.SETTLEMENT_COMPLETE_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '완료일 변경 실행',
          key: PERMISSION_SUBJECTS.SETTLEMENT_COMPLETE_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '롤백',
          key: PERMISSION_SUBJECTS.SETTLEMENT_COMPLETE_DATE_ADJUSTMENT,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
